import React from 'react'
import moment from 'moment'
import RecordSection from './_RecordSection'
import { Text, View } from '@react-pdf/renderer'
import InfoLine from './_InfoLine'

const HSIncident = ({ epcr }) => {
  const hasIncident = epcr.incident?.healthSafetyConcern
  if (!hasIncident) {
    return null
  }

  return (
    <RecordSection title="Health & Safety Incident">
      <View
        style={{
          width: '100%',
          gap: 5,
          fontSize: 10,
          paddingHorizontal: 5,
          paddingVertical: 2,
        }}
      >
        <Text
          style={{
            paddingVertical: 10,
            paddingHorizontal: 5,
            fontSize: 10,
            borderBottomStyle: 'solid',
            borderColor: '#1F3D7C',
          }}
        >
          {epcr.incident.healthSafetyDetails}
        </Text>
        <InfoLine
          label="H&S Incident Type"
          value={
            Array.isArray(epcr.incident.healthSafetyType)
              ? epcr.incident.healthSafetyType.join(', ')
              : epcr.incident.healthSafetyType
          }
        />
        <InfoLine
          label="Immediate Action Taken"
          value={epcr.incident.healthSafetyImmediateActionTaken ?? ''}
        />
        <InfoLine
          label="Organiser Notified"
          value={
            epcr.incident.healthSafetyEventOrganiserNotified ? 'Yes' : 'No'
          }
        />
        <InfoLine
          label="Additional Notes"
          value={epcr.incident.healthSafetyAdditionalNotesForOrganiser ?? ''}
        />
        <InfoLine
          label="Manager Review Notes"
          value={epcr.incident?.healthSafetyConcernManagerReview?.notes ?? ''}
        />
      </View>
    </RecordSection>
  )
}

export default HSIncident
